function computeObjectHash(obj: unknown): string {
    if (obj === null || obj === undefined) return '';

    // Преобразуем объект в строку и генерируем простой хеш
    const str = JSON.stringify(obj);
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash |= 0; // Преобразование в 32-битное целое
    }

    return hash.toString(16); // Преобразование в шестнадцатеричный формат
}


export const hash = {
    computeObjectHash
}